import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./reducers/authReducer";
import { cartReducer } from "./reducers/cartReducer";
import { categoryReducer } from "./reducers/categoryReducer";
import { favoriteReducer } from "./reducers/favoriteReducer";
import { productReducer } from "./reducers/productReducer";

const store = configureStore({
    reducer:{
        productReducer,
        cartReducer,
        authReducer,
        categoryReducer,
        favoriteReducer
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store